const getPipeHeaderConfig = (variant) => {
  const variantsConfigs = {
    defaultConfig: [
      {
        steps: [
          { path: "/ageRange/" },
          { path: "/stepAgeRange/" },
          { path: "/stepPrimaryGoal/" },
          { path: "/stepSocialProofWithReviews/" },
          { path: "/stepName/" },
          { path: "/stepCurrentBodyShape/" },
          { path: "/stepDietFamiliarity/" },
          { path: "/stepFastingIntro/" },
          { path: "/stepDailyHungerTime/" },
          { path: "/stepBreakfastTime/" },
          { path: "/stepLunchTime/" },
          { path: "/stepDinnerTime/" },
          { path: "/stepMealPreparation/" },
          { path: "/stepWeeklyActivityLevel/" },
          { path: "/stepWorkingHours/" },
          { path: "/stepDailyActivityLevel/" },
          { path: "/stepSecondaryGoal/" },
          { path: "/stepEncouragementWithCommunityNumbers/" },
          { path: "/stepExactAge/" },
          { path: "/stepHeight/" },
          { path: "/stepCurrentWeight/" },
          { path: "/stepGoalWeight/" },
          { path: "/stepProjectedProgressGraph/" },
          { path: "/stepSocialProofWithTestimonial/" },
          { path: "/stepDailyWalkingTime/" },
          { path: "/stepSleepHours/" },
          { path: "/stepCurrentWeightLossPractices/" },
          { path: "/stepDailyWaterIntake/" },
          { path: "/stepSupplementAndMedicationUsage/" },
          { path: "/stepHealthConditions/" },
          { path: "/stepEncouragementWithHonestyAppreciation/" },
          { path: "/stepUpdatedProjectedProgressGraph/" },
          { path: "/stepPlanGeneration/" },
          { path: "/stepEmailCapture/" },
          { path: "/stepRhetoricalQuestion1/" },
          { path: "/stepRhetoricalQuestion2/" },
          { path: "/stepRhetoricalQuestion3/" },
          { path: "/stepEncouragementAllSet/" },
          { path: "/stepPersonalCommitment/" },
          { path: "/stepResultsProgressGraph/" },
          { path: "/stepResultsBmi/" },
          { path: "/stepResultsHealthImprovements/" },
          { path: "/stepResultsSocialProofAndGuidance/" },
          { path: "/stepResultsStartNow/" },
        ],
      },
    ],
    "L1 Primary": [
      {
        steps: [
          { path: "/ageRange/" },
          { path: "/stepAgeRange/" },
          { path: "/stepPrimaryGoal/" },
          { path: "/stepSocialProofWithReviews/" },
          { path: "/stepName/" },
          { path: "/stepCurrentBodyShape/" },
          { path: "/stepDietFamiliarity/" },
          { path: "/stepFastingIntro/" },
          { path: "/stepDailyHungerTime/" },
          { path: "/stepBreakfastTime/" },
          { path: "/stepLunchTime/" },
          { path: "/stepDinnerTime/" },
          { path: "/stepMealPreparation/" },
          { path: "/stepWeeklyActivityLevel/" },
          { path: "/stepWorkingHours/" },
          { path: "/stepDailyActivityLevel/" },
          { path: "/stepSecondaryGoal/" },
          { path: "/stepEncouragementWithCommunityNumbers/" },
          { path: "/stepExactAge/" },
          { path: "/stepHeight/" },
          { path: "/stepCurrentWeight/" },
          { path: "/stepGoalWeight/" },
          { path: "/stepProjectedProgressGraph/" },
          { path: "/stepSocialProofWithTestimonial/" },
          { path: "/stepDailyWalkingTime/" },
          { path: "/stepSleepHours/" },
          { path: "/stepCurrentWeightLossPractices/" },
          { path: "/stepDailyWaterIntake/" },
          { path: "/stepSupplementAndMedicationUsage/" },
          { path: "/stepHealthConditions/" },
          { path: "/stepEncouragementWithHonestyAppreciation/" },
          { path: "/stepUpdatedProjectedProgressGraph/" },
          { path: "/stepPlanGeneration/" },
          { path: "/stepEmailCapture/" },
          { path: "/stepRhetoricalQuestion1/" },
          { path: "/stepRhetoricalQuestion2/" },
          { path: "/stepRhetoricalQuestion3/" },
          { path: "/stepEncouragementAllSet/" },
          { path: "/stepPersonalCommitment/" },
          { path: "/stepResultsProgressGraph/" },
          { path: "/stepResultsBmi/" },
          { path: "/stepResultsHealthImprovements/" },
          { path: "/stepResultsSocialProofAndGuidance/" },
          { path: "/stepResultsStartNow/" },
        ],
      },
    ],
    "Primary Applovin": [
      {
        steps: [
          { path: "/ageRange/" },
          { path: "/stepAgeRange/" },
          { path: "/stepPrimaryGoal/" },
          { path: "/stepSocialProofWithReviews/" },
          { path: "/stepName/" },
          { path: "/stepCurrentBodyShape/" },
          { path: "/stepDietFamiliarity/" },
          { path: "/stepFastingIntro/" },
          { path: "/stepDailyHungerTime/" },
          { path: "/stepBreakfastTime/" },
          { path: "/stepLunchTime/" },
          { path: "/stepDinnerTime/" },
          { path: "/stepMealPreparation/" },
          { path: "/stepWeeklyActivityLevel/" },
          { path: "/stepWorkingHours/" },
          { path: "/stepDailyActivityLevel/" },
          { path: "/stepSecondaryGoal/" },
          { path: "/stepEncouragementWithCommunityNumbers/" },
          { path: "/stepExactAge/" },
          { path: "/stepHeight/" },
          { path: "/stepCurrentWeight/" },
          { path: "/stepGoalWeight/" },
          { path: "/stepProjectedProgressGraph/" },
          { path: "/stepSocialProofWithTestimonial/" },
          { path: "/stepDailyWalkingTime/" },
          { path: "/stepSleepHours/" },
          { path: "/stepCurrentWeightLossPractices/" },
          { path: "/stepDailyWaterIntake/" },
          { path: "/stepEncouragementWithHonestyAppreciation/" },
          { path: "/stepUpdatedProjectedProgressGraph/" },
          { path: "/stepPlanGeneration/" },
          { path: "/stepEmailCapture/" },
          { path: "/stepRhetoricalQuestion1/" },
          { path: "/stepRhetoricalQuestion2/" },
          { path: "/stepRhetoricalQuestion3/" },
          { path: "/stepEncouragementAllSet/" },
          { path: "/stepPersonalCommitment/" },
          { path: "/stepResultsProgressGraph/" },
          { path: "/stepResultsBmi/" },
          { path: "/stepResultsHealthImprovements/" },
          { path: "/stepResultsStartNow/" },
        ],
      },
    ],
    "Water Fasting": [
      {
        steps: [
          { path: "/ageRange/" },
          { path: "/stepAgeRange/" },
          { path: "/stepPrimaryGoal/" },
          { path: "/stepSocialProofWithReviews/" },
          { path: "/stepName/" },
          { path: "/stepCurrentBodyShape/" },
          { path: "/stepDietFamiliarity/" },
          { path: "/stepFastingIntro/" },
          { path: "/stepDailyHungerTime/" },
          { path: "/stepBreakfastTime/" },
          { path: "/stepLunchTime/" },
          { path: "/stepDinnerTime/" },
          { path: "/stepMealPreparation/" },
          { path: "/stepWeeklyActivityLevel/" },
          { path: "/stepWorkingHours/" },
          { path: "/stepDailyActivityLevel/" },
          { path: "/stepSecondaryGoal/" },
          { path: "/stepEncouragementWithCommunityNumbers/" },
          { path: "/stepExactAge/" },
          { path: "/stepHeight/" },
          { path: "/stepCurrentWeight/" },
          { path: "/stepGoalWeight/" },
          { path: "/stepProjectedProgressGraph/" },
          { path: "/stepSocialProofWithTestimonial/" },
          { path: "/stepDailyWalkingTime/" },
          { path: "/stepSleepHours/" },
          { path: "/stepCurrentWeightLossPractices/" },
          { path: "/stepDailyWaterIntake/" },
          { path: "/stepEncouragementWaterFasting/" },
          { path: "/stepSupplementAndMedicationUsage/" },
          { path: "/stepHealthConditions/" },
          { path: "/stepEncouragementWithHonestyAppreciation/" },
          { path: "/stepUpdatedProjectedProgressGraph/" },
          { path: "/stepPlanGeneration/" },
          { path: "/stepEmailCapture/" },
          { path: "/stepRhetoricalQuestion1/" },
          { path: "/stepRhetoricalQuestion2/" },
          { path: "/stepRhetoricalQuestion3/" },
          { path: "/stepEncouragementAllSet/" },
          { path: "/stepPersonalCommitment/" },
          { path: "/stepResultsProgressGraph/" },
          { path: "/stepResultsBmi/" },
          { path: "/stepResultsHealthImprovements/" },
          { path: "/stepResultsSocialProofAndGuidance/" },
          { path: "/stepResultsStartNow/" },
        ],
      },
    ],
    "L3 Primary": [
      {
        titleKey: "goal_setting",
        steps: [
          { path: "/stepAgeRange/" },
          { path: "/stepPrimaryGoal/" },
          { path: "/stepSocialProofWithReviews/", skipCount: true },
          { path: "/stepName/" },
          { path: "/stepChangingEatingHabits/" },
          { path: "/stepStayOnTrack/", skipCount: true },
          { path: "/stepHealthyLifestyleInterests/" },
          { path: "/stepDietFamiliarity/" },
          { path: "/stepFastingIntro/" },
          { path: "/stepExpertQuote/", skipCount: true },
          { path: "/stepEasyToFollow/", skipCount: true },
          { path: "/stepBodyType/", completed: true  },
        ],
      },
      {
        titleKey: "my_eating_habits",
        steps: [
          { path: "/stepMealCount/" }, 
          { path: "/stepMealOfTheDay/" },
          { path: "/stepDailyHungerTime/" },
          { path: "/stepBreakfastTime/" },
          { path: "/stepLunchTime/" },
          { path: "/stepDinnerTime/" },
          { path: "/stepMealPreparation/" },
          { path: "/stepRecipesIntro/", completed: true },
        ],
  
      },
      {
        titleKey: "my_lifestyle",
        steps: [
          { path: "/stepWorkingHours/" },
          { path: "/stepDailyActivityLevel/" },
          { path: "/stepSecondaryGoal/" },
          { path: "/stepEncouragementWithCommunityNumbers/", skipCount: true },
          { path: "/stepExactAge/" },
          { path: "/stepHeight/" },
          { path: "/stepCurrentWeight/" },
          { path: "/stepGoalWeight/" },
          { path: "/stepProjectedProgressGraph/" },
          { path: "/stepSocialProofWithTestimonial/", skipCount: true },
          { path: "/stepDailyWalkingTime/" },
          { path: "/stepSleepHours/" },
          { path: "/stepEncouragementSleep/" },
          { path: "/stepCurrentWeightLossPractices/" },
          { path: "/stepDailyWaterIntake/" },
          { path: "/stepEncouragementWaterFasting/", completed: true }
        ],
      },
      {
        titleKey: "my_health_and_motivation",
        steps: [
          { path: "/stepSupplementAndMedicationUsage/" },
          { path: "/stepHealthConditions/" },
          { path: "/stepEncouragementWithHonestyAppreciation/" },
          { path: "/stepUpdatedProjectedProgressGraph/", completed: true },
          { path: "/stepPlanGeneration/", skipCount: true },
        ],
      }
    ],
    "WF Discount Code": [
      {
        steps: [
          { path: "/ageRange/" },
          { path: "/stepAgeRange/" },
          { path: "/stepPrimaryGoal/" },
          { path: "/stepSocialProofWithReviews/" },
          { path: "/stepName/" },
          { path: "/stepCurrentBodyShape/" },
          { path: "/stepDietFamiliarity/" },
          { path: "/stepFastingIntro/" },
          { path: "/stepDailyHungerTime/" },
          { path: "/stepBreakfastTime/" },
          { path: "/stepLunchTime/" },
          { path: "/stepDinnerTime/" },
          { path: "/stepMealPreparation/" },
          { path: "/stepWeeklyActivityLevel/" },
          { path: "/stepWorkingHours/" },
          { path: "/stepDailyActivityLevel/" },
          { path: "/stepSecondaryGoal/" },
          { path: "/stepEncouragementWithCommunityNumbers/" },
          { path: "/stepExactAge/" },
          { path: "/stepHeight/" },
          { path: "/stepCurrentWeight/" },
          { path: "/stepGoalWeight/" },
          { path: "/stepProjectedProgressGraph/" },
          { path: "/stepSocialProofWithTestimonial/" },
          { path: "/stepDailyWalkingTime/" },
          { path: "/stepSleepHours/" },
          { path: "/stepCurrentWeightLossPractices/" },
          { path: "/stepDailyWaterIntake/" },
          { path: "/stepEncouragementWaterFasting/" },
          { path: "/stepSupplementAndMedicationUsage/" },
          { path: "/stepHealthConditions/" },
          { path: "/stepEncouragementWithHonestyAppreciation/" },
          { path: "/stepUpdatedProjectedProgressGraph/" },
          { path: "/stepPlanGeneration/" },
          { path: "/stepEmailCapture/" },
          { path: "/stepRhetoricalQuestion1/" },
          { path: "/stepRhetoricalQuestion2/" },
          { path: "/stepRhetoricalQuestion3/" },
          { path: "/stepEncouragementAllSet/" },
          { path: "/stepPersonalCommitment/" },
          { path: "/stepResultsProgressGraph/" },
          { path: "/stepResultsBmi/" },
          { path: "/stepResultsHealthImprovements/" },
          { path: "/stepResultsSocialProofAndGuidance/" },
          { path: "/stepResultsStartNow/" },
          { path: "/stepRevealDiscount/" },
        ],
      }
    ],
    "WF Discount Code+ KB assist": [
      {
        steps: [
          { path: "/ageRange/" },
          { path: "/stepAgeRange/" },
          { path: "/stepPrimaryGoal/" },
          { path: "/stepSocialProofWithReviews/" },
          { path: "/stepName/" },
          { path: "/stepCurrentBodyShape/" },
          { path: "/stepDietFamiliarity/" },
          { path: "/stepFastingIntro/" },
          { path: "/stepDailyHungerTime/" },
          { path: "/stepBreakfastTime/" },
          { path: "/stepLunchTime/" },
          { path: "/stepDinnerTime/" },
          { path: "/stepMealPreparation/" },
          { path: "/stepWeeklyActivityLevel/" },
          { path: "/stepWorkingHours/" },
          { path: "/stepDailyActivityLevel/" },
          { path: "/stepSecondaryGoal/" },
          { path: "/stepEncouragementWithCommunityNumbers/" },
          { path: "/stepExactAge/" },
          { path: "/stepHeight/" },
          { path: "/stepCurrentWeight/" },
          { path: "/stepGoalWeight/" },
          { path: "/stepProjectedProgressGraph/" },
          { path: "/stepSocialProofWithTestimonial/" },
          { path: "/stepDailyWalkingTime/" },
          { path: "/stepSleepHours/" },
          { path: "/stepCurrentWeightLossPractices/" },
          { path: "/stepDailyWaterIntake/" },
          { path: "/stepEncouragementWaterFasting/" },
          { path: "/stepSupplementAndMedicationUsage/" },
          { path: "/stepHealthConditions/" },
          { path: "/stepEncouragementWithHonestyAppreciation/" },
          { path: "/stepUpdatedProjectedProgressGraph/" },
          { path: "/stepPlanGeneration/" },
          { path: "/stepEmailCapture/" },
          { path: "/stepRhetoricalQuestion1/" },
          { path: "/stepRhetoricalQuestion2/" },
          { path: "/stepRhetoricalQuestion3/" },
          { path: "/stepEncouragementAllSet/" },
          { path: "/stepPersonalCommitment/" },
          { path: "/stepResultsProgressGraph/" },
          { path: "/stepResultsBmi/" },
          { path: "/stepResultsHealthImprovements/" },
          { path: "/stepResultsSocialProofAndGuidance/" },
          { path: "/stepResultsStartNow/" },
          { path: "/stepRevealDiscount/" },
        ],
      }
    ],
  }

  return variantsConfigs[variant] || variantsConfigs.defaultConfig
}

export default getPipeHeaderConfig
